import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ModelCurrentTaskPiecesTime } from '../summary/model-current-task-pieces-time';

export class ModelCurrentTaskPiecesTimeBuilder {
  static fromJson(json) {
    return (json)
      ? new ModelCurrentTaskPiecesTime(
        parseNumber(json.timePerPiece),
        parseNumber(json.piecesPerHour),
        parseNumber(json.medianTimePerPiece),
        parseNumber(json.realTimePerPiece),
        parseNumber(json.lastTimePerPiece),
        json.article,
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ModelCurrentTaskPiecesTimeBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model-current-task-pieces-time.builder.ts